// extracted by mini-css-extract-plugin
export default {"root":"K3lM-tu4","option":"zZKLV4qH","withText":"-dkG8olK","isCurrent":"_5ydBHklK"};